import { useEffect, useState } from 'react';
import { api } from '../api';

export interface FirstDepositBonusStatus {
  percent: number;
  eligible: boolean;
  granted: boolean;
}

/**
 * Fetches the player's first-deposit-bonus status (drives the Home banner, the
 * welcome popup, and the deposit-screen callout). Best-effort: returns null on
 * any error so the surfaces simply don't render.
 */
export function useFirstDepositBonus() {
  const [data, setData] = useState<FirstDepositBonusStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get<FirstDepositBonusStatus>('/promotions/first-deposit-bonus')
      .then(res => { if (!cancelled) setData(res.data); })
      .catch(() => { if (!cancelled) setData(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { data, loading };
}
